// src/data/mock-natures.ts

import type { Nature } from '../core/types';

export const MOCK_NATURES: Nature[] = [
  // 中性性格（无修正，用作默认值）
  { id: 'hardy', name: '勤奋' },

  // ================= 生命性格 =================
  { id: 'chenmo', name: '沉默', plus: 'hp', minus: 'atk' },
  { id: 'pinghe', name: '平和', plus: 'hp', minus: 'spa' },
  { id: 'youyu', name: '忧郁', plus: 'hp', minus: 'def' },
  { id: 'cuxin', name: '粗心', plus: 'hp', minus: 'spd' },
  { id: 'tashi', name: '踏实', plus: 'hp', minus: 'spe' },

  // ================= 物攻性格 =================
  { id: 'dadan', name: '大胆', plus: 'atk', minus: 'def' },
  { id: 'tiaopi', name: '调皮', plus: 'atk', minus: 'spd' },
  { id: 'yonggan', name: '勇敢', plus: 'atk', minus: 'spe' },
  { id: 'chengqiang', name: '逞强', plus: 'atk', minus: 'hp' },
  { id: 'guzhi', name: '固执', plus: 'atk', minus: 'spa' },

  // ================= 魔攻性格 =================
  { id: 'congming', name: '聪明', plus: 'spa', minus: 'atk' },
  { id: 'zhuanzhu', name: '专注', plus: 'spa', minus: 'def' },
  { id: 'pianzhi', name: '偏执', plus: 'spa', minus: 'spd' },
  { id: 'lengjing', name: '冷静', plus: 'spa', minus: 'spe' },
  { id: 'lixing', name: '理性', plus: 'spa', minus: 'hp' },

  // ================= 速度性格 =================
  { id: 'danxiao', name: '胆小', plus: 'spe', minus: 'atk' },
  { id: 'kailang', name: '开朗', plus: 'spe', minus: 'spa' },
  { id: 'jizao', name: '急躁', plus: 'spe', minus: 'def' },
  { id: 'mangzhuang', name: '莽撞', plus: 'spe', minus: 'spd' },
  { id: 'reqing', name: '热情', plus: 'spe', minus: 'hp' },

  // ================= 物防性格 =================
  { id: 'wenzhong', name: '稳重', plus: 'def', minus: 'atk' },
  { id: 'tianzhen', name: '天真', plus: 'def', minus: 'spa' },
  { id: 'youxian', name: '悠闲', plus: 'def', minus: 'spe' },
  { id: 'lansan', name: '懒散', plus: 'def', minus: 'spd' },
  { id: 'tanshuai', name: '坦率', plus: 'def', minus: 'hp' },

  // ================= 魔防性格 =================
  { id: 'jingti', name: '警惕', plus: 'spd', minus: 'atk' },
  { id: 'haixiu', name: '害羞', plus: 'spd', minus: 'spa' },
  { id: 'wenshun', name: '温顺', plus: 'spd', minus: 'def' },
  { id: 'shenzhong', name: '慎重', plus: 'spd', minus: 'spe' },
  { id: 'jiaolv', name: '焦虑', plus: 'spd', minus: 'hp' },
];

export const NATURE_MAP: Record<string, Nature> = Object.fromEntries(
  MOCK_NATURES.map((n) => [n.id, n]),
);